import React from 'react';
import { FormField } from 'react-hooks-form';
import Select from 'packages/ui/SelectField';

function SelectFieldWrapper({ onChange, name, value, ...rest }) {
  return <Select {...rest} onChange={event => onChange(event.target.value)} value={value || ''} />;
}

function SelectField({ name, ...rest }) {
  return <FormField {...rest} component={SelectFieldWrapper} name={name} />;
}

export default SelectField;
